<template>
  <v-container 
    class="pt-0"
    fluid
  >
  <v-card
      class="ml-12 py-0 pt-2 rounded-0"
      color="rgba(255, 255, 255, 0.06)"
      max-width="455"
      max-height="300"
      style="overflow: auto;"
    >
        <v-list-item v-show="!atReplies.length" class="pb-1 atReply-color" style="text-align: center;">
            <v-list-item-subtitle class="atReply-color">
                Be the first one to @Reply!
            <v-textarea
                type="text"
                v-model="atReply"
                clear-icon="mdi-close-circle"
                background-color="white"
                @click:append="addNewAtReply"
                @keyup.enter="addNewAtReply"
                color="grey"
                autofocus="true"
                placeholder="Add a comment..."
                class="text-body-2"
                clearable
                rounded
                auto-grow 
                dense
                hide-details
                filled
                rows="1"
            ></v-textarea>
            </v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-for="atReply in atReplies" :key="atReply.id" class="pt-0 pr-2">
          <v-list-item-avatar size="26" style="align-self: start;">
              <v-img src="https://cdn.vuetifyjs.com/images/lists/1.jpg"></v-img>
          </v-list-item-avatar>
          <v-list-item-content class="pt-0">
                <v-bottom-sheet width="1200px" v-model="sheet">
                  <template v-slot:activator="{ on, attrs}">
                      <v-btn
                          class="pl-0 text-left"
                          color="transparent"
                          elevation="0"
                          max-width="150"
                          v-bind="attrs"
                          v-model="sheet"
                          v-on="on"
                          x-small
                        >
                          <v-list-item-title class="author atReply-color text-subtitle-2">{{atReply.author}}</v-list-item-title>
                          </v-btn>
                      </template>
                      <profilePage/>    
                  </v-bottom-sheet>
                  <v-list-item-subtitle class="text-caption wrap-text atReply-color font-weight-normal">{{atReply.atReplyText}}</v-list-item-subtitle>
                  <v-card-subtitle class="text-caption font-weight-light pa-0 atReply-color">
                      {{getAtReplyTime(atReply.created)}}
                      <span>·</span>
                      6 Likes
                  </v-card-subtitle> 
              </v-list-item-content>
                <v-icon
                  size="16" 
                  @click="atReply.liked=!atReply.liked"
                  :color="atReply.liked? 'red': 'white'"
                  >mdi-heart</v-icon>
                <v-icon
                  size="16"
                  @click="atReply.bookmark=!atReply.bookmark"
                  :color="atReply.bookmark? 'yellow': 'white'"
                  >mdi-clipboard-outline</v-icon>
          </v-list-item>
          <!--<addatReply v-if="showTextArea" :atReplies="atReplies"/>-->
        </v-card>
  </v-container>
</template>

<script>
const moment = require('moment')
moment().format()
export default {
    data: () => ({
        atReply: "",
        atReplies: [],
    }),
    methods: {
      addNewAtReply() {
          if(!this.atReply) return;
          const newAtReply = {
              id: Date.now(),
              atReplyText: this.atReply,
              liked: false,
              bookmark: false,
              dislike: false,
              created: Date.now(),
              author: 'Jerel Thompson',
          }
          this.atReplies = [...this.atReplies, newAtReply];
          this.atReply=""
      },
      getAtReplyTime(atReplyPublishedDate) {
        // Get todays date and the published date and find out how long
        // it's being since the article was posted.
        //
        //const m1 = new Date(); // prints: Toady's date
        const m2 = new Date(atReplyPublishedDate) // prints: Date of article
        const timeFromNow = moment(m2).fromNow() // Returns date that article was created
        return timeFromNow
      },
      showAtReplyTextArea(){
            this.showAtTextArea=!this.showAtTextArea;
        },
    },
}
</script>
// used css for custom scrollbar and a couple of classes.
<style scoped>
    ::-webkit-scrollbar {
    width: 10px;
    height: 12px;
    }
    ::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #ccc;  
    }
    ::-webkit-scrollbar-thumb:hover {
    background: #999;  
    }
    .wrap-text {
    white-space: normal;
    }/* To avoid the dots appering on the ending of the comments  */
    .atReply-color {
        color: #000 !important;
        font-family: sans-serif;
        font-size: 0.8rem;
        font-weight: 600;
    }
    .author {
        font-family: sans-serif;
        font-size: 1.1rem;
        font-weight: 900;
    }
</style>